// Every channel AdAudit records, in the order counts are shown.
export const CHANNELS = ["ppc", "gbp", "seo", "shopping", "lsa"];
